import React from 'react';
import { Box, FormControl } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import FieldError from 'app/components/FieldError';
import logger from 'app/utils/logger';

interface Props {
  accountOptions?: any;
  selectedToAccount?: any;
  onChangeToAccount?: (value: any) => void;
  control?: any;
  register?: any;
  disabled?: boolean;
  errors?: any;
  beneficiarData?: any;
  values?: any;
  dataForm?: any;
  ibanField?: any;
}

const GeneralDetailsInbank = (props: Props) => {
  const {
    accountOptions,
    selectedToAccount,
    errors,
    onChangeToAccount,
    register,
    control,
    disabled,
    beneficiarData,
    values,
    dataForm,
    ibanField,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          alignItems: 'flex-start',
          width: '100%',
          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Alan hesab'}
            placeholder={'Alan hesab'}
            rest={{
              ...register('toAccount', { value: values('toAccount') === undefined ? '' : values('toAccount') }),
              maxLength: 28,
            }}
            handleChange={onChangeToAccount}
            isValid={
              errors?.toAccount !== undefined ||
              beneficiarData?.error !== undefined ||
              dataForm?.error?.fields.cr_acc_no !== undefined
            }
            value={ibanField}
            disabled={disabled}
          />
          <FieldError
            error={
              errors.toAccount
                ? errors.toAccount
                : beneficiarData?.error?.fields.cr_acc_no
                ? { message: beneficiarData?.error?.fields.cr_acc_no }
                : dataForm?.error?.fields.cr_acc_no && { message: dataForm?.error?.fields.cr_acc_no }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Müştəri tipi'}
            placeholder={'Müştəri tipi'}
            rest={{ ...register('customerType') }}
            disabled={true}
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',
          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefisiar'}
            placeholder={'Benefisiar'}
            rest={{ ...register('beneficiarName') }}
            disabled={true}
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput title={'VÖEN'} placeholder={'VÖEN'} disabled={true} rest={{ ...register('beneficiarVoen') }} />
        </FormControl>
      </Box>
    </Box>
  );
};

export default GeneralDetailsInbank;
